export default __webpack_public_path__ + "static/media/logo.689134d6.png";